<template>
<div class="row mt-5">
  <div class="col-xl-5" v-if="checkForPermission(add_customer_tier_permission)">
    <customer-tier-form button_text="Add Customer Tier" @tierAction="addCustomerTier"/>
  </div>
  <div class="col-xl-1"></div>
  <div class="col-xl-6">
    <div class="card min-height">
      <div class="card-body">
        <h4 class="card-title mb-4">All Customer Tiers</h4>
        <TableLoading v-if="tiers.page === 0"/>
        <customer-tier-table v-else :rows="tiers.objects" @refetch="updateTiers"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import CustomerTierForm from "@/components/settings/customer-tier-form";
import TableLoading from "@/components/TableLoading";
import CustomerTierTable from "@/components/settings/customer-tier-table";
import {ALL_CUSTOMER_TIERS} from "@/gql";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import {permissions} from "@/router/permissions";
export default {
name: "customer-tier-component",
  components: {CustomerTierTable, TableLoading, CustomerTierForm},
  data(){
    return{
      tiers: {
        page: 0,
        objects: []
      },
      add_customer_tier_permission: permissions.add_customer_tier_permission,
    }
  },
  apollo: {
    tiers: {
      query: ALL_CUSTOMER_TIERS,
      variables (){
        return {
          page: 0,
          perPage: 30
        }
      }
    },
  },
  methods: {
    ... mapActions({
      addTier: 'user/addNewCustomerTier'
    }),
    async addCustomerTier(data){
      data.minimumInvoiceTotal = parseFloat(data.minimumInvoiceTotal)
      await this.addTier(data).then(() => {
        this.updateTiers()
        successToast('New tier added successfully')
      })
    },
    updateTiers(){
      this.$apollo.queries.tiers.refetch()
    }
  }
}
</script>

<style scoped>

</style>
